import selectors from 'circe/listing/selectors';
import { getState as getDomainState } from '../selectors';
import { REDUCER_NAME } from './constants';

const getState = state => getDomainState(state)[REDUCER_NAME];

export const {
  getResults,
  getIsFetching,
  getHasNext,
  getCurrentCursor,
  getCache,
  getFromCache,
  getHasCache,
  getFilters,
  getHasPrev,
  getNextCursor,
  getPrevCursor,
} = selectors(getState);
